module.exports = __webpack_public_path__ + "img/v3.570099d1.png";